<template>
  <div id="app">
    <app-header sistema="Censo" :usuario="usuario.nome" :unidade="usuario.unidade" />
    <loading v-if="loading" />

    <main>
      <router-view/>
    </main>

    <app-footer />
  </div>
</template>

<script>
    import AppHeader from './components/shared/header/AppHeader.vue'
    import AppFooter from './components/shared/footer/AppFooter.vue'
    import Loading from "./components/shared/loading/Loading.vue"
    import { captcha } from './components/shared/mixins/captcha'

    export default {
        mixins: [
            captcha
        ],
        components: {
            AppHeader,
            AppFooter,
            Loading
        },
        created () {
            console.log('Desenvolvido por Victor Pereira (ovictorpereira@gmail.com) e Rafael Iglezias (rafael.iglezias@gmail.com)');
        },
        mounted () {
            this.$store.dispatch('leitos/listarOpcoesSelect')
        },
        computed: {
            loading () {
                return this.$store.getters['sessao/getLoading']
            },
            usuario () {
                return this.$store.getters['sessao/getUsuario']
            }
        },
    }
</script>

<style>
#app {
    min-height: 100vh;
    min-width: 100%;
    display: flex;
    flex-direction: column;
}

main {
    flex-grow: 1;
}

header {
    margin-bottom: 0.6rem;
}
</style>
